"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.convoTags.name': 'Tagi Rozmowy',
    'tools.convoTags.description': 'Dodaj odpowiednie tagi do rozmów na podstawie kontekstu',
};
